export class ObjectUtils {
  static objectsEqual(o1: unknown, o2: unknown): boolean {
    try {
      if (o1 === o2) {
        return true;
      }

      if (typeof o1 !== 'object' || typeof o2 !== 'object' || o1 == null || o2 == null) {
        return false;
      }

      const keys1 = Object.keys(o1 as object);
      const keys2 = Object.keys(o2 as object);
      if (keys1.length !== keys2.length) {
        return false;
      }

      return keys1.every(key =>
        ObjectUtils.objectsEqual((o1 as { [key: string]: unknown })[key], (o2 as { [key: string]: unknown })[key]),
      );
    } catch (_error) {
      return false;
    }
  }

  static isEmpty(value: unknown) {
    try {
      if (Array.isArray(value)) {
        return !value.length;
      }

      if (value instanceof Map || value instanceof Set) {
        return !value.size;
      }

      if (ObjectUtils.isRecord(value)) {
        return !Object.keys(value).length;
      }

      return true;
    } catch (_error) {
      return true;
    }
  }

  static arraysEqual(a1: unknown[], a2: unknown[]) {
    try {
      return a1.length === a2.length && a1.every((o, idx) => ObjectUtils.objectsEqual(o, a2[idx]));
    } catch (_error) {
      return false;
    }
  }

  static arrayFromEnumValues<T extends string>(test: Record<string, string>): T[] {
    try {
      return Object.values(test) as T[];
    } catch (_error) {
      return [];
    }
  }

  static isLiteralObject = (obj: unknown): obj is object => {
    try {
      return !!obj && obj.constructor === Object;
    } catch (_error) {
      return false;
    }
  };

  static isRecord(obj: unknown): obj is Record<string, string> {
    try {
      return !!obj && typeof obj === 'object' && !Array.isArray(obj);
    } catch (_error) {
      return false;
    }
  }

  static alphabeticalOrder<T>(array: readonly T[], byField?: keyof T) {
    try {
      return [...array].sort((a, b) => {
        if (!byField) {
          if (typeof a === 'string' && typeof b === 'string') {
            return a.localeCompare(b);
          }

          return 0;
        }
        const fieldA = a[byField];
        const fieldB = b[byField];
        if (typeof fieldA === 'string' && typeof fieldB === 'string') {
          return fieldA.localeCompare(fieldB);
        }

        return 0;
      });
    } catch (_error) {
      return [...array];
    }
  }

  static deleteFields = <T extends Record<string, unknown>>(obj: T, fields: string[]): T => {
    try {
      const newObj = { ...obj };
      fields.forEach(field => {
        delete newObj[field];
      });
      return newObj;
    } catch (_error) {
      return { ...obj };
    }
  };
}
